import { useCallback, useEffect, useState } from 'react';
import { mask } from "remask";
import { cpf as cpfValidator } from 'cpf-cnpj-validator';

const CPF_MASK = '999.999.999-99';
const CPF_LENGTH = 14;

const useCTA = () => {
    const [cpf, setCpf] = useState("");
    const [cpfSanitized, setCpfSanitized] = useState("");
    const [isInvalid, setIsInvalid] = useState(false);
    const [disabledButton, setDisabledBtn] = useState(true);

    const validate = useCallback(() => {
        const isCPFTyped = cpf.length === CPF_LENGTH;
        if (isCPFTyped) {
            const validationState = cpfValidator.isValid(cpfSanitized);
            setIsInvalid(!validationState);
            setDisabledBtn(!validationState);
        }
    }, [cpfSanitized, cpf]);

    const handleOnChange = useCallback((value) => {
        setCpf(mask(value, CPF_MASK));
        setCpfSanitized(value.replace(/(\D)/gi, ""));
    }, []);

    const handleOnClick = useCallback(() => {
        if (!cpfSanitized || cpfSanitized.length !== 11) {
            setIsInvalid(true);
        } else if (!isInvalid) {
            const cpfB64 = btoa(cpfSanitized);
            const url = APP_SCORE_URL + `?identify=${cpfB64}`;
            window.open(url, '_blank');
        }
    }, [cpfSanitized, isInvalid]);

    const handleOnBlur = useCallback(() => {
        validate();
    }, [validate]);

    useEffect(() => {
        validate();
    }, [cpfSanitized, validate]);

    return {
        handleOnChange,
        handleOnClick,
        handleOnBlur,
        cpf,
        isInvalid,
        disabledButton
    };
}

export default useCTA;
